define([
	"dojo/_base/declare"
], function(declare) {

	return declare(null, {
		// Boolean: indicates if drag event occurred in edit mode
		bDrag: false,

		// Boolean: indicates if translation edit in effect
		bTranslate: false,

		// Number: total translation so far
		tx: 0,
		ty: 0,

		// Boolean: indicates if rotation edit in effect
		bRotate: false,

		// Point: center of shape
		ptCenter: null,

		// Number: rotation of shape in radians - updates as rotation is applied
		radians: 0,

		// Number: index of scale anchor point
		nScale: 0,

		// Point: anchor point of scale
		ptScaleAnchor: null,

		// Point: scale point that is dragged
		ptScale: null,

		// Boolean: indicates direction of scaling
		sx: false,
		sy: false
	});
});